import {
  END_CALL_LIST,
  SWITCH_TAB,
  TOGGLE_MOBILE_FILTERS,
  TOGGLE_ALERT,
  UPDATE_CALL_DATA,
  UPDATE_PREVIEW_DATA,
  SHOW_OVERLAY_FILTERS,
  HIDE_OVERLAY_FILTERS
} from '../actions/ui';

export default function (state = {}, action) {
  switch (action.type) {
  case END_CALL_LIST:
    return { ...state, previewOverlayCallListId: null, previewOverlayTaskId: null };
  case SWITCH_TAB:
    return { ...state, currentTab: action.tab };
  case TOGGLE_MOBILE_FILTERS:
    return { ...state, mobileFiltersVisible: !state.mobileFiltersVisible };
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case UPDATE_CALL_DATA:
    return {
      ...state,
      previewOverlayCallId: action.callId,
      previewOverlayCallListId: action.callListId
    };
  case UPDATE_PREVIEW_DATA:
    return {
      ...state,
      previewOverlayCallListId: null,
      previewOverlayRecordId: action.contactId,
      previewOverlayRecordType: action.contactType,
      previewOverlayTaskId: action.taskId
    };
  case SHOW_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: true };
  case HIDE_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: false };  
  default:
    return state;
  }
}
